import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { BaseTranslationButtonProps } from '../../../utils/props';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';
import TranslationButton from './TranslationButton';

import './style.scss';

interface LeanWithDisclaimerTranslationButtonProps extends BaseTranslationButtonProps {
    showDisclaimerText?: boolean;
}

const LeanWithDisclaimerTranslationButton = ({
    toggled = false,
    loading = false,
    showDisclaimerText = true,
    onClick = noop,
}: LeanWithDisclaimerTranslationButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        let hoverTimer;

        if (isHovered) {
            hoverTimer = setTimeout(() => {
                setIsOpen(true);
            }, 1500);
        } else {
            clearTimeout(hoverTimer);
            setIsOpen(false);
        }

        return () => {
            clearTimeout(hoverTimer);
        };
    }, [isHovered]);

    const isOriginal = !toggled || loading;
    const titleSuffix = isOriginal ? 'original' : 'translated';

    return (
        <div className="lean-toggled-disclaimer-translation-button">
            <div className={classNames('flex', { 'flex-center': !showDisclaimerText })}>
                {loading ? (
                    <i className={classNames('loading-icon', { 'm-t-4': showDisclaimerText })} />
                ) : (
                    <i className={classNames('vendor-disclaimer', { 'm-t-4': showDisclaimerText })} />
                )}
                <div>
                    {showDisclaimerText ? (
                        <I18n
                            k={`machine_translation.lean_with_disclaimer.${titleSuffix}`}
                            templates={{
                                span: () => (
                                    <div className="popover-wrapper">
                                        <TranslationButton
                                            toggled={toggled}
                                            loading={loading}
                                            isOpen={isOpen}
                                            onClick={onClick}
                                            setIsHovered={setIsHovered}
                                        />
                                    </div>
                                ),
                            }}
                        />
                    ) : (
                        <TranslationButton
                            toggled={toggled}
                            loading={loading}
                            isOpen={isOpen}
                            onClick={onClick}
                            setIsHovered={setIsHovered}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default withTranslationButtonWrapper(
    LeanWithDisclaimerTranslationButton
) as React.FC<LeanWithDisclaimerTranslationButtonProps>;
